// Simplified-Chinese strings for the notes area. Keys are the exact English source strings.
export const notes: Record<string, string> = {
  // notes/Index.tsx
  'Notes · Pinpoint': '笔记 · Pinpoint',
  'Every timestamped insight and rich note, grouped by video.': '所有带时间戳的要点与富文本笔记，按视频分组。',
  '+ Note': '+ 笔记',
  'Search your notes…': '搜索你的笔记…',
  'Nothing here yet': '这里还什么都没有',
  'Take a timestamped note on a video, or write a rich note.': '在视频上记一条带时间戳的笔记，或写一条富文本笔记。',
  'Notes without a video': '没有关联视频的笔记',
  note: '条笔记',
  notes: '条笔记',
  Note: '笔记',

  // notes/New.tsx
  'New note · Pinpoint': '新建笔记 · Pinpoint',
  'New rich-text note': '新建富文本笔记',
  Title: '标题',
  'Write anything — paste images, format text…': '随意书写——粘贴图片、设置文本格式…',
  'tags, comma…': '标签，用逗号分隔…',
  'Save note': '保存笔记',

  // TimelinePanel.tsx
  'Delete this note? This cannot be undone.': '删除这条笔记？此操作无法撤销。',
  'Delete this segment? Its notes stay, but become loose. This cannot be undone.':
    '删除这个片段？片段中的笔记会保留，但将变为游离笔记。此操作无法撤销。',
  'drop here → loose': '拖放到此处 → 游离',
  '+ Segment': '+ 片段',
  Organize: '整理',
  'No segments or notes yet — add one above to start your timeline.':
    '还没有片段或笔记——在上方添加一个，开始你的时间轴。',
  Unanchored: '未锚定',
  gap: '间隔',
  playing: '播放中',

  // timeline/forms.tsx
  Categories: '分类',
  Tags: '标签',
  Body: '正文',
  'Notes…': '笔记…',
  Start: '起点',
  End: '终点',
  remove: '移除',
  '+ end time (make range)': '+ 终点时间（设为时间段）',
  'Untimed (no time)': '不计时（无时间）',
  'Add note': '添加笔记',
  'Edit note': '编辑笔记',
  'Pin to current time': '标记到当前时间',
  'Pin': '标记',
  'Pinned': '标记点',
  Cancel: '取消',
  'Need a start (or mark untimed)': '需要一个起点（或标记为不计时）',
  'e.g. Arm drag': '例如：手臂拖拽',
  'e.g. Foot sweep entry': '例如：扫腿入场',
  'Need a start': '需要一个起点',
  '+ end time (playhead)': '+ 终点时间（播放头位置）',
  'No end = open-ended (auto-maps nothing).': '不设终点 = 开放式（不自动映射任何内容）。',
  'Add segment': '添加片段',
  'New segment': '新建片段',
  'New note': '新建笔记',
  start: '起点',
  'end (blank = point)': '终点（留空 = 时间点）',
  'end (blank=open)': '终点（留空 = 开放式）',
  Save: '保存',
  Delete: '删除',
}
